import { type } from '@/utils/type'


export const MISSIONGLOBAL_REQUEST = type('MISSIONGLOBAL_REQUEST')
export const MISSIONGLOBAL_SUCCESS = type('MISSIONGLOBAL_SUCCESS')
export const MISSIONGLOBAL_ERROR = type('MISSIONGLOBAL_ERROR')

export const MISSIONGLOBAL_ENSURE_LIST = type('MISSIONGLOBAL_ENSURE_LIST')

export const MISSIONGLOBAL_SELECT_DETAIL_REQUEST = type('MISSIONGLOBAL_SELECT_DETAIL_REQUEST')
export const MISSIONGLOBAL_SELECT_DETAIL_SUCCESS = type('MISSIONGLOBAL_SELECT_DETAIL_SUCCESS')
export const MISSIONGLOBAL_SELECT_DETAIL_ERROR = type('MISSIONGLOBAL_SELECT_DETAIL_ERROR')
export const MISSIONGLOBAL_SELECT_DETAIL = type('MISSIONGLOBAL_SELECT_DETAIL')
export const MISSIONGLOBAL_OPEN_DETAIL = type('MISSIONGLOBAL_OPEN_DETAIL')

export const MISSIONGLOBAL_SAVE_REQUEST = type('MISSIONGLOBAL_SAVE_REQUEST')
export const MISSIONGLOBAL_SAVE_SUCCESS = type('MISSIONGLOBAL_SAVE_SUCCESS')
export const MISSIONGLOBAL_SAVE_ERROR = type('MISSIONGLOBAL_SAVE_ERROR')

export const MISSIONGLOBAL_RUN_SIMULATION_REQUEST = type('MISSIONGLOBAL_RUN_SIMULATION_REQUEST')
export const MISSIONGLOBAL_RUN_SIMULATION_ERROR = type('MISSIONGLOBAL_RUN_SIMULATION_ERROR')

export const MISSIONGLOBAL_RUN_COVERAGE_GRID_REQUEST = type('MISSIONGLOBAL_RUN_COVERAGE_GRID_REQUEST')
export const MISSIONGLOBAL_RUN_COVERAGE_GRID_SUCCESS = type('MISSIONGLOBAL_RUN_COVERAGE_GRID_SUCCESS')
export const MISSIONGLOBAL_RUN_COVERAGE_GRID_ERROR = type('MISSIONGLOBAL_RUN_COVERAGE_GRID_ERROR')

export const MISSIONGLOBAL_RUN_COVERAGE_SIMULATION_REQUEST = type('MISSIONGLOBAL_RUN_COVERAGE_SIMULATION_REQUEST')
export const MISSIONGLOBAL_RUN_COVERAGE_SIMULATION_SUCCESS = type('MISSIONGLOBAL_RUN_COVERAGE_SIMULATION_SUCCESS')
export const MISSIONGLOBAL_RUN_COVERAGE_SIMULATION_ERROR = type('MISSIONGLOBAL_RUN_COVERAGE_SIMULATION_ERROR')

export const MISSIONGLOBAL_RUN_FORMATION_SIMULATION_REQUEST = type('MISSIONGLOBAL_RUN_FORMATION_SIMULATION_REQUEST')
export const MISSIONGLOBAL_RUN_FORMATION_SIMULATION_SUCCESS = type('MISSIONGLOBAL_RUN_FORMATION_SIMULATION_SUCCESS')
export const MISSIONGLOBAL_RUN_FORMATION_SIMULATION_ERROR = type('MISSIONGLOBAL_RUN_FORMATION_SIMULATION_ERROR')

export const MISSIONGLOBAL_ABORT_SIMULATION_REQUEST = type('MISSIONGLOBAL_ABORT_SIMULATION_REQUEST')
export const MISSIONGLOBAL_ABORT_SIMULATION_ERROR = type('MISSIONGLOBAL_ABORT_SIMULATION_ERROR')

export const MISSIONGLOBAL_SET_MODIFIED_ADM = type('MISSIONGLOBAL_SET_MODIFIED_ADM')
export const MISSIONGLOBAL_UPDATE_MODIFIED_ADM = type('MISSIONGLOBAL_UPDATE_MODIFIED_ADM')
export const MISSIONGLOBAL_CANCEL_MODIFIED_ADM = type('MISSIONGLOBAL_CANCEL_MODIFIED_ADM')

export const MISSIONGLOBAL_UPDATE_FILTER_ADM = type('MISSIONGLOBAL_UPDATE_FILTER_ADM')

export const MISSIONGLOBAL_OPEN_LAST_SIMULATION = type('MISSIONGLOBAL_OPEN_LAST_SIMULATION')
export const MISSIONGLOBAL_UNSELECT_DETAIL = type('MISSIONGLOBAL_UNSELECT_DETAIL')

export const SIMULATION_SYNC_MISSSIONPLAN_SENSOR = type('SIMULATION_SYNC_MISSSIONPLAN_SENSOR')

export const MISSIONGLOBAL_DELETE_REQUEST = type('MISSIONGLOBAL_DELETE_REQUEST')
export const MISSIONGLOBAL_DELETE_SUCCESS = type('MISSIONGLOBAL_DELETE_SUCCESS')
export const MISSIONGLOBAL_DELETE_ERROR = type('MISSIONGLOBAL_DELETE_ERROR')

export const MISSIONGLOBAL_EXTERNAL_UPDATE = type('MISSIONGLOBAL_EXTERNAL_UPDATE')

